import { TkOrderListing } from '../components/OrderTable/types.ts';
import { OrderTab } from '../types.ts';

export const getOrdersForTab = (orders: TkOrderListing[], activeTab: OrderTab) => {
  if (activeTab === 'active') {
    return orders.filter(
      ({ isArchived, isCompleted }) => isArchived === false && isCompleted === false,
    );
  }

  if (activeTab === 'archived') {
    return orders.filter(
      ({ isArchived, isTraining }) => isArchived === true && isTraining === false,
    );
  }

  if (activeTab === 'completed') {
    return orders.filter(({ isCompleted }) => isCompleted === true);
  }

  // 'training'
  return orders.filter(({ isTraining }) => isTraining === true);
};
